import React, { useState } from "react";
import {
  Facebook,
  Twitter,
  Instagram,
  Mail,
  Phone,
  MapPin,
  ArrowRight,
} from "lucide-react";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle newsletter signup
    console.log("Newsletter signup:", email);
    setEmail("");
  };

  // const quickLinks = [
  //   { name: "About Us", href: "#" },
  //   { name: "Contact", href: "#" },
  //   { name: "Terms & Conditions", href: "#" },
  //   { name: "Privacy Policy", href: "#" },
  //   { name: "FAQs", href: "#" },
  //   { name: "Refund Policy", href: "#" },
  // ];

  const supportInfo = [
    { icon: Phone, text: "+27 79 394 0313", href: "tel:+27 79 394 0313" },
    {
      icon: Mail,
      text: "support@weride.club",
      href: "mailto:support@weride.club",
    },
    {
      icon: MapPin,
      text: "Johannesburg, South Africa",
      href: "https://www.google.com/maps/place/Johannesburg/@-26.1714277,27.8752134,11z/data=!3m1!4b1!4m6!3m5!1s0x1e950c68f0406a51:0x238ac9d9b1d34041!8m2!3d-26.205647!4d28.0337185!16zL20vMGcyODQ?entry=ttu&g_ep=EgoyMDI1MDMxNi4wIKXMDSoASAFQAw%3D%3D",
    },
  ];

  return (
    <footer className="bg-white mt-12 border-t border-gray-100">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto pt-16 pb-8 px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div>
              <h2 className="text-2xl font-bold text-green-600">WeRide</h2>
              <p className="text-gray-600 mt-2">
                Making inter-city travel in South Africa easy, comfortable, and
                affordable.
              </p>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              <a
                href="#"
                className="bg-gray-100 p-2 rounded-full hover:bg-green-100 transition-colors duration-300"
              >
                <Facebook className="w-5 h-5 text-gray-600 hover:text-green-600" />
              </a>
              <a
                href="#"
                className="bg-gray-100 p-2 rounded-full hover:bg-green-100 transition-colors duration-300"
              >
                <Twitter className="w-5 h-5 text-gray-600 hover:text-green-600" />
              </a>
              <a
                href="#"
                className="bg-gray-100 p-2 rounded-full hover:bg-green-100 transition-colors duration-300"
              >
                <Instagram className="w-5 h-5 text-gray-600 hover:text-green-600" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-6">Quick Links</h3>
            <nav className="space-y-4">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block text-gray-600 hover:text-green-600 transition-colors duration-300"
                >
                  {link.name}
                </a>
              ))}
            </nav>
          </div> */}

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <div className="space-y-4">
              {supportInfo.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="flex items-center space-x-3 text-gray-600 hover:text-green-600 transition-colors duration-300"
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.text}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Newsletter</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <p className="text-gray-600">
                Stay updated with our latest routes and offers.
              </p>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="w-full px-4 py-3 rounded-lg bg-gray-100 border-2 border-transparent focus:border-green-600 focus:ring-0 transition-colors duration-300"
                  required
                />
                <button
                  type="submit"
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-green-600 text-white p-2 rounded-md hover:bg-green-700 transition-colors duration-300"
                >
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-600 text-sm">
              © {new Date().getFullYear()} WeRide. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a
                href="/privacy-policy"
                className="text-sm text-gray-600 hover:text-green-600 transition-colors duration-300"
              >
                Terms
              </a>
              <a
                href="/privacy-policy"
                className="text-sm text-gray-600 hover:text-green-600 transition-colors duration-300"
              >
                Privacy
              </a>
              <a
                href="#"
                className="text-sm text-gray-600 hover:text-green-600 transition-colors duration-300"
              >
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
